import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-flag",
  templateUrl: "./med-icon-flag.component.html",
})
export class MedIconFlagComponent extends SvgMixinComponent {}
